<template>
  <router-link
    v-if="to"
    :to="to"
    class="a-link"
    :class="[linkType, linkColor, linkBold]"
  >
    <slot />
  </router-link>
  <a
    v-else-if="href"
    :href="href"
    class="a-link"
    :target="targetBlank"
    :class="[linkType, linkColor, linkBold]"
  >
    <slot />
  </a>
  <span v-else class="a-link" :class="[linkType, linkColor, linkBold]">
    <slot />
  </span>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'ALink',
  props: {
    type: {
      type: String,
      default: '',
      validator(type) {
        return ['', 'underline'].includes(type as string);
      }
    },
    color: {
      type: String,
      default: '',
      validator(color) {
        return ['', 'black'].includes(color as string);
      }
    },
    bold: {
      type: Boolean,
      default: false
    },
    href: {
      type: String,
      default: ''
    },
    to: {
      type: String,
      default: ''
    },
    blank: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    linkType() {
      return this.type ? `a-link--type-${this.type}` : '';
    },
    linkColor() {
      return this.color ? `a-link--color-${this.color}` : '';
    },
    linkBold() {
      return this.bold ? `a-link--bold` : '';
    },
    targetBlank() {
      return this.blank ? '_blank' : '';
    }
  }
});
</script>

<style lang="scss" scoped>
.a-link {
  font-size: 14px;
  color: #1179ce;
  text-decoration: none;

  &--bold {
    font-weight: 600;
  }

  &--color-black {
    color: #484848;
  }

  &--type-underline {
    text-decoration: underline;
  }
}
</style>
